export const firstNames = {
 human: ["Alric", "Bran", "Cassia", "Dorian", "Elara", "Garrick", "Helena", "Marcus", "Pickle", "Tobias", "Snork", "Bubbles", "Adrian", "Beatrice", "Cedric", 
            "Daphne", "Edwin", "Fiona", "Gareth", "Isolde"],

 elf: ["Aeris", "Caelion", "Elaria", "Faelar", "Ilyana", "Luthien", "Mythas", "Sylvar", "Twinkletoes", "Vaelis", "Glitterdew", "Moonbean", "Aerendyl", "Caladriel",
            "Eryndor", "Faelwen", "Ithilmar", "Lorien", "Myrrhiel", "Thandor"],

 tiefling: ["Azazel", "Balthora", "Cazamir", "Delmira", "Erevan", "Kaelis", "Lilura", "Malrik", "Snickerdoom", "Zareth", "Fizzburn", "Skreech", "Azura", 
              "Caelthorn", "Drexia", "Infernis", "Kytheris", "Malzahar", "Ravyn", "Zerathis"],

 githyanki: ["Vlakith", "Zaarth", "Kith'rak", "Thraak", "Yrrvek", "Xarzith", "Drenn", "Sarthaal", "Snagblat", "Grizzlevek", "Wobthrakk", "Plibnib", "Vyrrek", 
              "Zaathar", "Korrith", "Thryss", "Xalvak", "Draanth", "Sorrik", "Velrath"],

 halfOrc: ["Goruk", "Thokk", "Vorga", "Dreg", "Mogra", "Brug", "Hruk", "Zagga", "Snort", "Grumpo", "Bashley", "Meatloaf", "Gorash", "Throg", "Morgra", "Drak", 
            "Brakka", "Hruknar", "Zogar", "Krusk"],
 
 gnome: ["Fizzwick", "Boddle", "Nimble", "Pipkin", "Tinket", "Wizzle", "Blinky", "Gadget", "Snickerdoodle", "Fuzzle", "Wobblepop", "Ticklefoot", "Bilbin", 
            "Coggle", "Nissa", "Fonkin", "Tinkwick", "Zilpip", "Boddynock", "Wizzlefink"],

 halfling: ["Pippin", "Milo", "Rosie", "Samwise", "Lily", "Tuck", "Bungo", "Doddle", "Nibble", "Twinkle", "Frodo", "Jollybean", "Merric", "Seraphina", 
                "Cade", "Lyle", "Poppy", "Finnan", "Roscoe", "Euphemia"],

 drow: ["Zaknafein", "Liriel", "Drizzt", "Pharaun", "Vierna", "Belwar", "Zilvra", "Ryld", "Quenthel", "Nalfein", "Faeryl", "Shakti", "Dinin", "Viconia",
            "Squeakers", "Giggletwist", "Snickerdash", "Z'ress", "Eilistraee", "Jarlaxle"],

 dwarf: ["Thorin", "Balin", "Dain", "Gimli", "Fundin", "Bofur", "Dwalin", "Oin", "Gloin", "Fili", "Kili", "Durin", "Brokk", "Eitri",
            "Stumpy", "Chubbycheeks", "Grumblebeard", "Thrain", "Dori", "Nori"],

 halfElf: ["Aelar", "Lyra", "Theren", "Elara", "Kaelen", "Selene", "Vaelis", "Rylan", "Maris", "Talin", "Carys", "Eldrin", "Liora", "Darian", "Snazzlepuff",
             "Wiggles", "Fizzlebop", "Korrin", "Jasara", "Fenric"],

 dragonborn: ["Arjhan", "Balasar", "Donhar", "Kriv", "Medrash", "Nadarr", "Pandjed", "Rhogar", "Sora", "Tarhun", "Torinn", "Verthandi", "Zarann", "Kava",
                "Snappyclaw", "Flapscale", "Wobblesnout", "Drogath", "Kavaxas", "Thava"],
};

export const lastNames = {
 fighter: ["Ironfist", "Stonebreaker", "Shieldheart", "Battleborn", "Steelgrip", "Hammerfell", "Blazeforge", "Grimstrike", "Meatshield", "Punchsworth", 
            "Clankbottom", "Thudson", "Ironshield", "Battlehammer", "Stonecleaver", "Warbrand", "Steelspire", "Axesworn", "Shieldbane", "Grimsteel"],

 rogue: ["Shadowstep", "Nightrunner", "Lockwhisper", "Silversneak", "Darkveil", "Quickhands", "Shadecloak", "Whisperthorn", "Pickpocketson", "Sneakybeans", 
            "Flipdagger", "Skitterfoot", "Shadowfang", "Daggerford", "Nightwhisper", "Silvershadow", "Crowcloak", "Blackpouch", "Veilmantle", "Whisperfang"],

 warlock: ["Doomwhisper", "Gravebind", "Voidcaller", "Hexborn", "Nightchant", "Soulmark", "Curseblood", "Ebonflare", "Wigglescourge", "Snarlwand", "Gloombottom",
            "Dreadpickle", "Darkweaver", "Soulreaver", "Hexweald", "Voidmantle", "Cursebrand", "Nighthex", "Dreadspire", "Ebonveil"],
 
 cleric: ["Lightbearer", "Dawnsoul", "Blessingvale", "Sunmantle", "Faithward", "Holystrike", "Gracelumen", "Sanctibright", "Praywell", "Halohead", "Smitehug",
            "Beneduck", "Lightward", "Graceborne", "Dawnshield", "Holybrook", "Sanctus", "Prayerborn", "Faithcrest", "Blessingmar"],

 bard: ["Songweaver", "Silverstrings", "Lyricfall", "Harpsong", "Fiddlestick", "Chimewind", "Whistledown", "Balladheart", "Jinglesnap", "Tunetwister", 
            "Mirthquake", "Plucknslide", "Melodyweave", "Fiddlehart", "Balladwind", "Songspire", "Chantleaf", "Minstrelshade", "Rhythmsong", "Harpshine"],

 wizard: ["Spellward", "Nightshade", "Starfire", "Mooncloak", "Frostbane", "Grimward", "Runebinder", "Shadowcrest", "Blinkwhisper", "Fizzlebang", "Wandtwirl", 
            "Hexsprocket", "Spellbinder", "Mystcloak", "Arcanehart", "Runeshard", "Frostveil", "Nightgaze", "Hexflame", "Stormscribe"],

 barbarian: ["Ironhide", "Stormbreaker", "Bloodaxe", "Rageborn", "Skullcrusher", "Thunderfury", "Grimjaw", "Stonefist", "Bashgut", "Ogrebiter", "Rumblebelly",
                "Furywhisker", "Rageclaw", "Bonecrusher", "Frostfang", "Ironmaw", "Skullbane", "Thunderhoof", "Bloodrager", "Stormhowl"],

 druid: ["Greenleaf", "Oakenshield", "Moonbrook", "Stormbark", "Wildgrove", "Mistwalker", "Earthwhisper", "Shadowbranch", "Sunroot", "Thornwood", "Windrider",
            "Dewclaw", "Fernshade", "Briarheart", "Fungusfoot", "Mossmunch", "Toadstool", "Riverrun", "Leafsong", "Starbloom"],

 monk: ["Silentwind", "Ironfist", "Stonefoot", "Calmstride", "Shadowpalm", "Stillwater", "Cloudwalker", "Swiftbreeze", "Moonstrike", "Quietstep", "Windwhisper",
            "Steelbark", "Sunshadow", "Lightfoot", "Bellyflop", "Snorehand", "Twinkletoes", "Mistgrip", "Stonewhisper", "Peacebinder"],

 paladin: ["Brightshield", "Lightbringer", "Goldheart", "Dawnblade", "Justiceborn", "Faithguard", "Lioncrest", "Holyflame", "Silverhelm", "Virtuesong",
                "Stormvalor", "Truthwarden", "Gracedawn", "Ironvalor", "Bubblehammer", "Shinybottom", "Blessedtoes", "Gloryforge", "Sunwarden", "Honorfield"],

 sorcerer: ["Flameheart", "Stormborn", "Brightspark", "Emberfall", "Starflare", "Duskwind", "Firebrand", "Shadowflare", "Windwhisper", "Blazewind", "Moonfire",
                "Sparkcaster", "Ashenforge", "Cinderveil", "Fizzlestorm", "Bubblesnatch", "Zapcrackle", "Stormflicker", "Glowspark", "Mistflare"]
};

export const generateName  = (race, classType) => {
    //first save the arrays of names for the specified race and class type into a variable and then include a string literal as a fallback option
    let first = firstNames[race] || ["NameLess"];
    let last = lastNames[classType] || ["Nobody"];

     console.log("first.length = ", first.length);
    console.log("last.length = ", last.length);

    //then randomly select one of them
    let firstName = first[Math.floor(Math.random() * first.length)];
    let lastName = last[Math.floor(Math.random() * last.length)];
   
    return `${firstName} ${lastName}`;
}